import { HOW_IT_WORKS_STEPS } from '../constants/howItWorks';

export const getJsonLdHowToVariant = req => {
  const pageUrl = req.getPagePath('how-it-works');

  const steps = HOW_IT_WORKS_STEPS.map(item => {
    const itemListElement = [];

    item.bulletPoints.forEach(point => {
      itemListElement.push({
        '@type': 'HowToStep',
        name: req.trans(point.titleKey),
        text: req.trans(point.textKey)
      });
    });

    return {
      '@type': 'HowToStep',
      name: req.trans(item.titleKey),
      text: req.trans(item.descriptionKey),
      url: pageUrl,
      itemListElement
    };
  });

  return {
    '@context': 'https://schema.org',
    '@type': 'HowTo',
    name: req.trans('listing.how-to-book.section-main-title'),
    description: req.trans('how_it_works.alt.hero.title'),
    step: steps
  };
};

export const getJsonLdHowTo = req => {
  const pageUrl = req.getPagePath('how-it-works');

  return {
    '@context': 'https://schema.org',
    '@type': 'HowTo',
    name: req.trans('how_it_works.alt.hero.title'),
    step: [
      {
        '@type': 'HowToStep',
        name: req.trans('how_it_works.alt.step1.title'),
        text: req.trans('how_it_works.alt.step1.text'),
        url: pageUrl
      },
      {
        '@type': 'HowToStep',
        name: req.trans('how_it_works.alt.step2.title'),
        text: req.trans('how_it_works.alt.step2.text'),
        url: pageUrl
      },
      {
        '@type': 'HowToStep',
        name: req.trans('how_it_works.alt.step3.title'),
        text: req.trans('how_it_works.alt.step3.text'),
        url: pageUrl
      },
      {
        '@type': 'HowToStep',
        name: req.trans('how_it_works.alt.step4.title'),
        text: `${req.trans('how_it_works.alt.step4.text1')}${req.trans(
          'how_it_works.alt.step4.text2'
        )}`,
        url: pageUrl
      }
    ]
  };
};
